import { IApplyingCompany } from "./applyingCompany";
import { IUser } from "./user";

export enum CustomerPreferredRateEnum {
  FIRST_MONTH_RATE = "FIRST_MONTH_RATE",
  MONTHLY_INTEREST_RATE = "MONTHLY_INTEREST_RATE",
  YEARLY_INTEREST_RATE = "YEARLY_INTEREST_RATE",
}

export const RATE_TO_BID_KEY_MAP = {
  [CustomerPreferredRateEnum.FIRST_MONTH_RATE]: "firstMonthInterestRate",
  [CustomerPreferredRateEnum.MONTHLY_INTEREST_RATE]:
    "comparableMonthlyInterestRate",
  [CustomerPreferredRateEnum.YEARLY_INTEREST_RATE]:
    "comparableYearlyInterestRate",
} as const;

export type RateKeysType =
  (typeof RATE_TO_BID_KEY_MAP)[keyof typeof RATE_TO_BID_KEY_MAP];

export const enum LoanApplicationVerificationFailureReasons {
  NOT_ELIGIBLE_FOR_HELP = "NOT_ELIGIBLE_FOR_HELP",
  DUPLICATE_EXISTS = "DUPLICATE_EXISTS",
  NO_COMPANY_DATA = "NO_COMPANY_DATA",
  SUBJECT_TO_EU_SANCTIONS = "SUBJECT_TO_EU_SANCTIONS",
  IS_PEP = "IS_PEP",
  NO_SIGNING_RIGHTS = "NO_SIGNING_RIGHTS",
  NO_CREDIT_CHECK = "NO_CREDIT_CHECK",
}

export enum LoanApplicationStates {
  DRAFT = "DRAFT",
  CREATED = "CREATED",
  ADVICE = "ADVICE",
  OPEN_FOR_BIDS = "OPEN_FOR_BIDS",
  REJECTED = "REJECTED",
  SUBJECT_TO_EU_SANCTIONS = "SUBJECT_TO_EU_SANCTIONS",
  NO_BIDS_RECEIVED = "NO_BIDS_RECEIVED",
  BIDS_REJECTED_BY_CUSTOMER = "BIDS_REJECTED_BY_CUSTOMER",
  BID_SELECTED = "BID_SELECTED",
  PAYOUT_RECEIVED_BY_CUSTOMER = "PAYOUT_RECEIVED_BY_CUSTOMER",
}

const enum LoanApplicationProduct {
  COMPANY_LOAN = "COMPANY_LOAN",
  FACTORING = "FACTORING",
  REAL_ESTATE = "REAL_ESTATE",
  ADVISORY = "ADVISORY",
  LEASING = "LEASING",
}

interface IAssignedToAdminUser {
  email: string;
  firstName: string;
  lastName: string;
  mobilePhoneNumber: string;
  profileImage: {
    lowResolutionUrl: string;
  };
}

export interface ILoanApplication {
  id: string | undefined;
  customerPreferredRate: CustomerPreferredRateEnum;
  alternativeRate: CustomerPreferredRateEnum;
  verificationFailureReasons: LoanApplicationVerificationFailureReasons[];
  state: LoanApplicationStates;
  contactPerson: IUser;
  applyingCompany: IApplyingCompany;
  product: LoanApplicationProduct;
  applicationAttractiveness: number;
  assignedToAdminUser: IAssignedToAdminUser;
  eligibleForLeasingBids: boolean;
}

export interface ICustomerCompany {
  id?: string;
  name: string;
  typeDisplayName?: string;
  organisationNumber: string;
}

export interface ICurrentLoanApplication {
  applyingCompany: Record<string, ICustomerCompany>;
  boardMembers: Record<string, string>[];
}

export interface IBoardMemberRole {
  roleCode: string;
  roleName: string;
}

export interface IBoardMember {
  id?: string;
  ssn: string;
  firstName: string;
  lastName: string;
  roles: IBoardMemberRole[];
}
